module.exports = __webpack_public_path__ + "static/media/SpicyRice-Regular.ffc7a5e5.ttf";